import logo from './logo.svg'
import './ExitPage.scss'
const ExitPage = (props) => {
  const {
    onChangeView,
  } = props

  return <div className="ExitPage">
    <div className="ExitPage-opacity" />
    <button className="ExitToStart" onClick={()=>onChangeView("MenuPage")}>
      Created with REACT-ITCH
      <img src={logo} className="logo" alt="logo" draggable="false" />
      Click to run game EATch.io
    </button>
    <div className="ExitPageBar">
      Exclusive game for &nbsp;
      <a href="https://itch.io/jam/3-gnomes-game-jam-2024" target="_blank" rel="noreferrer"> #3gnomesgamejam </a> &nbsp; | &nbsp; 2024
    </div>

  </div>
}

export default ExitPage